import { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@/components/ui';
import { useTranslation } from '@/providers/app-provider/app-provider';

const AgeVerificationModal = () => {
  const { t } = useTranslation();

  // Default to `true` (verified) so the modal renders closed during SSR and
  // initial hydration — `sessionStorage` only exists in the browser. The real
  // verification state is read in the effect below, which then opens the modal
  // if needed. Without this guard the component throws `sessionStorage is not
  // defined` at server render and breaks SSR for the whole layout.
  const [isAgeVerified, setIsAgeVerified] = useState(true);
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsAgeVerified(sessionStorage.getItem('isAgeVerified') !== null);
    setIsHydrated(true);
  }, []);

  const handleAccept = () => {
    setIsAgeVerified(true);
  };

  const handleReject = () => {
    sessionStorage.removeItem('isAgeVerified');
    window.location.href = 'https://google.com';
  };

  useEffect(() => {
    if (!isHydrated) return;
    if (isAgeVerified) {
      sessionStorage.setItem('isAgeVerified', 'true');
    } else {
      sessionStorage.removeItem('isAgeVerified');
    }
  }, [isAgeVerified, isHydrated]);

  return (
    <Modal
      isOpen={!isAgeVerified}
      aria-labelledby="age-verification"
      backdrop="blur"
      isDismissable={false}
      hideCloseButton
    >
      <ModalContent className="flex flex-col items-center justify-center text-center">
        <ModalHeader>
          <h2 className="text-xl font-semibold">{t?.common.ageVerificationModal.title}</h2>
        </ModalHeader>
        <ModalBody>
          <p>{t?.common.ageVerificationModal.description}</p>
          <p>{t?.common.ageVerificationModal.confirmationText}</p>
        </ModalBody>
        <ModalFooter className="flex justify-center gap-4">
          <Button color="danger" onClick={handleReject} className="w-36">
            {t?.common.ageVerificationModal.rejectButton}
          </Button>
          <Button color="success" onClick={handleAccept} className="w-36">
            {t?.common.ageVerificationModal.acceptButton}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AgeVerificationModal;
